/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CountDemandesATraiterResponse,
  GetDemandeValidationDetailResponse,
  GetFacetsResponse,
  GetQuestionnaireDevisResponse,
  GetRisqueDevisResponse,
  GetSimulationDocumentsResponseDto,
  ListDemandesValidationCommand,
  ListDemandesValidationResponse,
  OperationResponse,
  RefuserDemandeCommand,
  SimulerRetarificationCommand,
  SimulerRetarificationResponse,
  UrlOperationResponse,
  ValiderAvecModificationsCommand,
  ValiderDemandeCommand,
} from '../models/index';
import {
    CountDemandesATraiterResponseFromJSON,
    CountDemandesATraiterResponseToJSON,
    GetDemandeValidationDetailResponseFromJSON,
    GetDemandeValidationDetailResponseToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetQuestionnaireDevisResponseFromJSON,
    GetQuestionnaireDevisResponseToJSON,
    GetRisqueDevisResponseFromJSON,
    GetRisqueDevisResponseToJSON,
    GetSimulationDocumentsResponseDtoFromJSON,
    GetSimulationDocumentsResponseDtoToJSON,
    ListDemandesValidationCommandFromJSON,
    ListDemandesValidationCommandToJSON,
    ListDemandesValidationResponseFromJSON,
    ListDemandesValidationResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    RefuserDemandeCommandFromJSON,
    RefuserDemandeCommandToJSON,
    SimulerRetarificationCommandFromJSON,
    SimulerRetarificationCommandToJSON,
    SimulerRetarificationResponseFromJSON,
    SimulerRetarificationResponseToJSON,
    UrlOperationResponseFromJSON,
    UrlOperationResponseToJSON,
    ValiderAvecModificationsCommandFromJSON,
    ValiderAvecModificationsCommandToJSON,
    ValiderDemandeCommandFromJSON,
    ValiderDemandeCommandToJSON,
} from '../models/index';

export interface GetValidationRequestRequest {
    demandeId: string;
}

export interface GetValidationRequestDocumentUrlRequest {
    demandeId: string;
    fileId: string;
}

export interface GetValidationRequestDocumentsRequest {
    demandeId: string;
}

export interface GetValidationRequestQuestionnaireRequest {
    demandeId: string;
}

export interface GetValidationRequestRiskRequest {
    demandeId: string;
}

export interface GetValidationRequestsRequest {
    listDemandesValidationCommand: ListDemandesValidationCommand;
}

export interface GetValidationRequestsFacetsRequest {
    listDemandesValidationCommand: ListDemandesValidationCommand;
}

export interface RefuseRequestRequest {
    demandeId: string;
    refuserDemandeCommand: RefuserDemandeCommand;
}

export interface SimulateValidationRepricingRequest {
    demandeId: string;
    simulerRetarificationCommand: SimulerRetarificationCommand;
}

export interface ValidateRequestRequest {
    demandeId: string;
    validerDemandeCommand: ValiderDemandeCommand;
}

export interface ValidateRequestWithChangesRequest {
    demandeId: string;
    validerAvecModificationsCommand: ValiderAvecModificationsCommand;
}

/**
 * 
 */
export class ValidationsApi extends runtime.BaseAPI {

    /**
     * Permission BackOffice.Validations.Read.
     * Number of pending requests addressed to the current validator
     */
    async getPendingValidationRequestsCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CountDemandesATraiterResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/validations/a-traiter/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountDemandesATraiterResponseFromJSON(jsonValue));
    }

    /**
     * Permission BackOffice.Validations.Read.
     * Number of pending requests addressed to the current validator
     */
    async getPendingValidationRequestsCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CountDemandesATraiterResponse> {
        const response = await this.getPendingValidationRequestsCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * peutRepondre is true when the request is pending and addressed to the current user. Permission BackOffice.Validations.Read. 
     * Validation request, quote summary and re-pricing model
     */
    async getValidationRequestRaw(requestParameters: GetValidationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDemandeValidationDetailResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling getValidationRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDemandeValidationDetailResponseFromJSON(jsonValue));
    }

    /**
     * peutRepondre is true when the request is pending and addressed to the current user. Permission BackOffice.Validations.Read. 
     * Validation request, quote summary and re-pricing model
     */
    async getValidationRequest(requestParameters: GetValidationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDemandeValidationDetailResponse> {
        const response = await this.getValidationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * URL valid 60 minutes; the file must belong to the documents of the quote. Permission BackOffice.Validations.Read, request addressed to the current user. 
     * Temporary URL of a document of the quote
     */
    async getValidationRequestDocumentUrlRaw(requestParameters: GetValidationRequestDocumentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UrlOperationResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling getValidationRequestDocumentUrl().'
            );
        }

        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getValidationRequestDocumentUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/documents/{fileId}/url`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))).replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters['fileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UrlOperationResponseFromJSON(jsonValue));
    }

    /**
     * URL valid 60 minutes; the file must belong to the documents of the quote. Permission BackOffice.Validations.Read, request addressed to the current user. 
     * Temporary URL of a document of the quote
     */
    async getValidationRequestDocumentUrl(requestParameters: GetValidationRequestDocumentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UrlOperationResponse> {
        const response = await this.getValidationRequestDocumentUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Same list as GET documents/devis/{quoteId}. Permission BackOffice.Validations.Read, request addressed to the current user. 
     * Documents of the quote
     */
    async getValidationRequestDocumentsRaw(requestParameters: GetValidationRequestDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSimulationDocumentsResponseDto>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling getValidationRequestDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/documents`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSimulationDocumentsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Same list as GET documents/devis/{quoteId}. Permission BackOffice.Validations.Read, request addressed to the current user. 
     * Documents of the quote
     */
    async getValidationRequestDocuments(requestParameters: GetValidationRequestDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSimulationDocumentsResponseDto> {
        const response = await this.getValidationRequestDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Answers of the risk questionnaire of the quote, read only. Permission BackOffice.Validations.Read, request addressed to the current user. 
     * Questionnaire answers of the quote
     */
    async getValidationRequestQuestionnaireRaw(requestParameters: GetValidationRequestQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuestionnaireDevisResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling getValidationRequestQuestionnaire().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/questionnaire`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuestionnaireDevisResponseFromJSON(jsonValue));
    }

    /**
     * Answers of the risk questionnaire of the quote, read only. Permission BackOffice.Validations.Read, request addressed to the current user. 
     * Questionnaire answers of the quote
     */
    async getValidationRequestQuestionnaire(requestParameters: GetValidationRequestQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuestionnaireDevisResponse> {
        const response = await this.getValidationRequestQuestionnaireRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Insured risk of the quote, read only: the subscribers and the view of its insurance branch (MRI: the coproperty; GLI: the property or the park, with the tenants). The branch view is absent for the other branches. Same authorization as the questionnaire: request addressed to the current user, any status. 
     * Insured risk of the quote
     */
    async getValidationRequestRiskRaw(requestParameters: GetValidationRequestRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRisqueDevisResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling getValidationRequestRisk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/risque`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRisqueDevisResponseFromJSON(jsonValue));
    }

    /**
     * Insured risk of the quote, read only: the subscribers and the view of its insurance branch (MRI: the coproperty; GLI: the property or the park, with the tenants). The branch view is absent for the other branches. Same authorization as the questionnaire: request addressed to the current user, any status. 
     * Insured risk of the quote
     */
    async getValidationRequestRisk(requestParameters: GetValidationRequestRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRisqueDevisResponse> {
        const response = await this.getValidationRequestRiskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Paginated inbox of the current validator. filters.toProcess true (default) = pending requests, false = answered, cancelled or invalidated ones. searchString searches the quote and file identifiers, broker, platform, product, tunnel and subscriber. Permission BackOffice.Validations.Read. 
     * List the validation requests addressed to the current validator
     */
    async getValidationRequestsRaw(requestParameters: GetValidationRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDemandesValidationResponse>> {
        if (requestParameters['listDemandesValidationCommand'] == null) {
            throw new runtime.RequiredError(
                'listDemandesValidationCommand',
                'Required parameter "listDemandesValidationCommand" was null or undefined when calling getValidationRequests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/validations/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListDemandesValidationCommandToJSON(requestParameters['listDemandesValidationCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDemandesValidationResponseFromJSON(jsonValue));
    }

    /**
     * Paginated inbox of the current validator. filters.toProcess true (default) = pending requests, false = answered, cancelled or invalidated ones. searchString searches the quote and file identifiers, broker, platform, product, tunnel and subscriber. Permission BackOffice.Validations.Read. 
     * List the validation requests addressed to the current validator
     */
    async getValidationRequests(requestParameters: GetValidationRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDemandesValidationResponse> {
        const response = await this.getValidationRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facets of the inbox (same payload as the list). Keys: tunnels -> tunnelIds, brokers -> brokerIds. Each facet is computed without its own filter. Permission BackOffice.Validations.Read. 
     * Facets of the validator inbox
     */
    async getValidationRequestsFacetsRaw(requestParameters: GetValidationRequestsFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['listDemandesValidationCommand'] == null) {
            throw new runtime.RequiredError(
                'listDemandesValidationCommand',
                'Required parameter "listDemandesValidationCommand" was null or undefined when calling getValidationRequestsFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/validations/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListDemandesValidationCommandToJSON(requestParameters['listDemandesValidationCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facets of the inbox (same payload as the list). Keys: tunnels -> tunnelIds, brokers -> brokerIds. Each facet is computed without its own filter. Permission BackOffice.Validations.Read. 
     * Facets of the validator inbox
     */
    async getValidationRequestsFacets(requestParameters: GetValidationRequestsFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getValidationRequestsFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The quote is blocked for good. Fails with \"déjà traitée par X\" when another validator answered in the meantime. Permission BackOffice.Validations.Manage. 
     * Refuse the quote (message mandatory)
     */
    async refuseRequestRaw(requestParameters: RefuseRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling refuseRequest().'
            );
        }

        if (requestParameters['refuserDemandeCommand'] == null) {
            throw new runtime.RequiredError(
                'refuserDemandeCommand',
                'Required parameter "refuserDemandeCommand" was null or undefined when calling refuseRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/refuser`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefuserDemandeCommandToJSON(requestParameters['refuserDemandeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * The quote is blocked for good. Fails with \"déjà traitée par X\" when another validator answered in the meantime. Permission BackOffice.Validations.Manage. 
     * Refuse the quote (message mandatory)
     */
    async refuseRequest(requestParameters: RefuseRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.refuseRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Comparator path, nothing is written. Permission BackOffice.Validations.Read. 
     * Price the quote with the validator changes
     */
    async simulateValidationRepricingRaw(requestParameters: SimulateValidationRepricingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulerRetarificationResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling simulateValidationRepricing().'
            );
        }

        if (requestParameters['simulerRetarificationCommand'] == null) {
            throw new runtime.RequiredError(
                'simulerRetarificationCommand',
                'Required parameter "simulerRetarificationCommand" was null or undefined when calling simulateValidationRepricing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/simuler`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SimulerRetarificationCommandToJSON(requestParameters['simulerRetarificationCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimulerRetarificationResponseFromJSON(jsonValue));
    }

    /**
     * Comparator path, nothing is written. Permission BackOffice.Validations.Read. 
     * Price the quote with the validator changes
     */
    async simulateValidationRepricing(requestParameters: SimulateValidationRepricingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulerRetarificationResponse> {
        const response = await this.simulateValidationRepricingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fails with \"déjà traitée par X\" when another validator answered in the meantime. Permission BackOffice.Validations.Manage. 
     * Accept the quote as is
     */
    async validateRequestRaw(requestParameters: ValidateRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling validateRequest().'
            );
        }

        if (requestParameters['validerDemandeCommand'] == null) {
            throw new runtime.RequiredError(
                'validerDemandeCommand',
                'Required parameter "validerDemandeCommand" was null or undefined when calling validateRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/valider`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValiderDemandeCommandToJSON(requestParameters['validerDemandeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Fails with \"déjà traitée par X\" when another validator answered in the meantime. Permission BackOffice.Validations.Manage. 
     * Accept the quote as is
     */
    async validateRequest(requestParameters: ValidateRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.validateRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The server re-prices the quote from the command (at least one change required). Fails with \"déjà traitée par X\" when another validator answered in the meantime. Permission BackOffice.Validations.Manage. 
     * Write the validator changes on the quote and accept it
     */
    async validateRequestWithChangesRaw(requestParameters: ValidateRequestWithChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['demandeId'] == null) {
            throw new runtime.RequiredError(
                'demandeId',
                'Required parameter "demandeId" was null or undefined when calling validateRequestWithChanges().'
            );
        }

        if (requestParameters['validerAvecModificationsCommand'] == null) {
            throw new runtime.RequiredError(
                'validerAvecModificationsCommand',
                'Required parameter "validerAvecModificationsCommand" was null or undefined when calling validateRequestWithChanges().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/validations/{demandeId}/valider-avec-modifications`.replace(`{${"demandeId"}}`, encodeURIComponent(String(requestParameters['demandeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValiderAvecModificationsCommandToJSON(requestParameters['validerAvecModificationsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * The server re-prices the quote from the command (at least one change required). Fails with \"déjà traitée par X\" when another validator answered in the meantime. Permission BackOffice.Validations.Manage. 
     * Write the validator changes on the quote and accept it
     */
    async validateRequestWithChanges(requestParameters: ValidateRequestWithChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.validateRequestWithChangesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
